import React from "react";
import styles from "./IR330C.module.scss";

const IR330CPageIntro = () => {
  return (
    <div className={styles.irdFormDetails}>
      <div className={styles.formBox}>
        <div className="page-title-2">
        <div className={styles.boxInlineData}>
          <div className={styles.title}>Employee</div>
          <div className={styles.details}>
            <p className="mb-0">
              Give this completed form to your employer. <br />
              If you receive a <strong>main benefit or NZ superannuation</strong>, give this form to Work and Income.{" "}
<br />
              If you do not complete sections 1, 2 and 3, your employer must deduct tax from your pay at the non-notified rate of 45%
(plus earners’ levy).{" "}
            </p>
          </div>
        </div>
        </div>
      </div>
    </div>
  );
};

export default IR330CPageIntro;
